import { SVGProps } from 'react'

export const MapMarkerIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      {...props}
    >
      <path
        d='M8 1C4.84799 1 2 3.29004 2 6.83537C2 9.09572 3.83756 11.759 7.50373 14.8251C7.78987 15.0583 8.2146 15.0583 8.50074 14.8251C12.1624 11.759 14 9.09996 14 6.83537C14 3.29004 11.152 1 8 1ZM8 8.11185C7.17288 8.11185 6.50224 7.47149 6.50224 6.69118C6.50224 5.91087 7.17735 5.2705 8 5.2705C8.82265 5.2705 9.49776 5.91087 9.49776 6.69118C9.49776 7.47149 8.82265 8.11185 8 8.11185Z'
        fill='currentColor'
      />
    </svg>
  )
}
